<template>
    <div id="claim-date-filter-last-week">
        <b-row>
            <b-col cols="12" sm="6" class="text-left date-filter">
                <b-row>
                    <b-col cols="12" sm="6">
                        <label for="datepicker-debut">Date Début</label>
                        <b-form-datepicker size="sm" v-model="startDate" placeholder="Date Début" id="datepicker-debut"
                            :max="new Date()" />
                    </b-col>
                    <b-col cols="12" sm="6">
                        <label for="datepicker-fin">Date Fin</label>
                        <b-form-datepicker size="sm" v-model="endDate" placeholder="Date Fin" id="datepicker-fin"
                            :max="new Date()" />
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12" sm="6" class="text-right">
                <b-button size="sm" variant="success" class="mt-2" @click="$emit('filterClicked', { sDate: startDate, eDate: endDate })">
                    <feather-icon icon="FilterIcon" class="mr-50 ml-50" />
                    Filtrer
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    data() {
        const today = new Date();
        const lastWeek = new Date();
        lastWeek.setDate(today.getDate() - 7);
        return {
            startDate: lastWeek.toISOString().split('T')[0],
            endDate: today.toISOString().split('T')[0],
        }
    },
}
</script>
<style lang="scss">
@media (max-width: 769px) {
    .date-filter {
        padding-top: 1rem;
    }
}
</style>
